import { ACQUIRED_STATUS } from '@travel/traveler-core/constants/salesPromotion';

import type { AcquiredCoupon } from 'AcquiredCoupons-Types';
import {
  INCENTIVE_CALCULATION_METHOD,
  INCENTIVE_METHOD,
  OFFER_TYPE,
} from 'constants/salesPromotion';
import type { SalesPromotion } from 'ProviderList-Types';
import type { CouponDetails } from 'SalesPromotion-Types';

/**
 * Checks if the discount price should be displayed
 * @param salesPromotions salesPromotion array
 * @returns true is discount price should be displayed, false if not
 */
export const shouldDisplayDiscountPrice = (salesPromotions: SalesPromotion[]) => {
  /*
   * If there is change in price, discount should be shown
   * In detail should meet all conditions:
   * - incentive is discount
   * - direct offer or acquired coupon
   */
  return salesPromotions?.some(
    (sp) =>
      sp.incentive.method === INCENTIVE_METHOD.DISCOUNT &&
      (sp.offerType === OFFER_TYPE.DIRECT ||
        sp.acquiredStatus === ACQUIRED_STATUS.ACQUIRED_BY_USER),
  );
};

/**
 * Get all the applied sales promotion ids
 * @param salesPromotions sales promotion array
 * @returns array of ids
 */
export const getAppliedSalesPromotionIds = (salesPromotions: SalesPromotion[]) => {
  return salesPromotions
    ?.filter(
      (sp) =>
        sp.acquiredStatus === ACQUIRED_STATUS.APPLIED_AUTOMATICALLY ||
        sp.acquiredStatus === ACQUIRED_STATUS.ACQUIRED_BY_USER,
    )
    .map((sp) => sp.id);
};

/**
 * Judges whether to show disclaimer for local amount
 * @param coupon coupon details information
 * @param currency user currency
 * @returns true if should show disclaimer
 */
export const shouldDisplayCouponDisclaimer = (
  coupon?: CouponDetails | AcquiredCoupon,
  currency?: string,
) => {
  return (
    coupon?.localCurrency !== currency &&
    (coupon?.incentiveAmount?.incentiveCalcMethod === INCENTIVE_CALCULATION_METHOD.EXACT_AMOUNT ||
      (coupon?.incentiveAmount?.incentiveCalcMethod === INCENTIVE_CALCULATION_METHOD.PERCENT &&
        coupon?.incentiveAmount?.limit))
  );
};
